module.exports = __webpack_public_path__ + "media/assets/svg/logos/leanbit_bianco-8b950e68bb17fffb3eea6d13e246b4cd.svg";